import { render, staticRenderFns } from "./InputReviewPerilaku.vue?vue&type=template&id=a1cec3ce&scoped=true&lang=html&"
import script from "./InputReviewPerilaku.vue?vue&type=script&lang=js&"
export * from "./InputReviewPerilaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cec3ce",
  null
  
)

export default component.exports